import React from "react";
import Button from "../atoms/Button/Button"; // make sure your Button component is imported
import {
  ButtonWrapper,
  ErrorIcon,
  ErrorMessageItem,
  ErrorMessageList,
  ErrorModalWrapper,
  ErrorTitle,
} from "./styles";

interface ErrorModalProps {
  errorMessages: { [field: string]: string };
  onClose: () => void;
}

const ErrorModalContent: React.FC<ErrorModalProps> = ({
  errorMessages,
  onClose,
}) => (
  <ErrorModalWrapper>
    <ErrorTitle>
      <ErrorIcon />
      ERROR
    </ErrorTitle>
    <ErrorMessageList>
      {Object.entries(errorMessages).map(([field, message]) => (
        <ErrorMessageItem key={field}>
          <strong>{field}:</strong> {message}
        </ErrorMessageItem>
      ))}
    </ErrorMessageList>
    <ButtonWrapper>
      <Button onClick={onClose}>Close</Button>
    </ButtonWrapper>
  </ErrorModalWrapper>
);

export default ErrorModalContent;
